export default "__VITE_ASSET__6fb54559__"